import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const TravelerPage = lazy(() => import('./pages/TravelerPage'));
const HostPage = lazy(() => import('./pages/HostPage'));
const AddOnsPage = lazy(() => import('./pages/AddOnsPage'));
const CheckoutSuccess = lazy(() => import('./pages/CheckoutSuccess'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const VerificationComplete = lazy(() => import('./pages/VerificationComplete'));

const RouteLoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--cream)' }}>
    <div className="animate-pulse text-gray-400">Loading...</div>
  </div>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Routes>
          <Route path="/" element={<TravelerPage />} />
          <Route path="/traveler" element={<TravelerPage />} />
          <Route path="/hosts" element={<HostPage />} />
          <Route path="/add-ons" element={<AddOnsPage />} />
          <Route path="/addons" element={<AddOnsPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/verification-complete" element={<VerificationComplete />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
